import { Plugin } from "..";
import { defaultCursorValueDataOptions } from "./cursor-value-data-options";

const id = "cursor-value";

export const CursorValue: Plugin = {
	id,
	type: "cursor",
	header: {
		visible: false,
		edit: false,
		fullscreen: false,
	},
	name: "cursorValue",
	component: defineAsyncComponent(() => import("./CursorValuePlugin.vue")),
	config: null,
	dataConfig: defineAsyncComponent(() => import("./CursorValueDataConfig")),
	defaultDataResolver: () => structuredClone(defaultCursorValueDataOptions),
	defaultOptionsResolver: () => undefined,
	dimension: {
		minHeight: 4,
		minWidth: 4,
	},

	currentVersion: 1,
	migrations: {},
};
